import React, { useState, useEffect } from "react";

const api = {
  key: "122a19f9186cd18bdfca3a7e8a4623ef",
  base: "https://api.openweathermap.org/data/2.5/",
};

const WeatherWidget = () => {
  const [query, setQuery] = useState(``);
  const [weather, setWeather] = useState([]);
  const [change, setChange] = useState(0);

  useEffect(() => {
    const intervalTwo = setInterval(() => {
      setChange((prevState) => prevState + 1);
    }, 5);
    if (change === 100) {
      return () => {
        clearInterval(intervalTwo);
      };
    }
  }, []);

  const search = (e) => {
    if (e.key === "Enter") {
      fetch(`${api.base}weather?q=${query}&units=metric&APPID=${api.key}`)
        .then((res) => res.json())
        .then((result) => {
          setWeather(result);
          setQuery("");
          console.log(result);
        });
    }
  };

  const dateBuilder = (d) => {
    let months = [
      "Stycznia",
      "Lutego",
      "Marca",
      "Kwietnia",
      "Maja",
      "Czerwca",
      "Lipca",
      "Sierpnia",
      "Września",
      "Października",
      "Listopada",
      "Grudnia",
    ];

    let days = [
      "Niedziela, ",
      "Poniedziałek, ",
      "Wtorek, ",
      "Środa, ",
      "Czwartek, ",
      "Piątek, ",
      "Sobota, ",
    ];

    let day = days[d.getDay()];
    let date = d.getDate();
    let month = months[d.getMonth()];
    let year = d.getFullYear();

    return `${day} ${date} ${month} ${year}`;
  };

  return (
    <div
      style={{ opacity: change / 100 }}
      className={
        typeof weather.main != "undefined"
          ? weather.main.temp > 16
            ? "weather_container"
            : "weather_container cold"
          : "weather_container closed"
      }
    >
      <main>
        <div className="search-box">
          <input
            type="text"
            className="search-bar"
            placeholder="Wpisz miasto..."
            onChange={(e) => setQuery(e.target.value)}
            value={query}
            onKeyPress={search}
          />
        </div>
        {typeof weather.main != "undefined" ? (
          <div>
            <div className="location-box">
              <div className="location">
                {weather.name}, <span>{weather.sys.country}</span>
              </div>
              <div className="date">{dateBuilder(new Date())}</div>
            </div>
            <div className="weather-box">
              <div className="temp">{Math.round(weather.main.temp)}°C</div>

              <div className="weather-today">{weather.weather[0].main}</div>
            </div>
          </div>
        ) : (
          ""
        )}
      </main>
    </div>
  );
};

export default WeatherWidget;
